import type { UUID } from '@/utils/uuid';

export const secretQueryKeys = {
  lists: () => ['secrets'] as const,
  list: (tenantId?: UUID) => ['secrets', tenantId] as const,
  details: () => ['secret'] as const,
  detail: (tenantId?: UUID, secretId?: UUID) =>
    ['secret', tenantId, secretId] as const,
  templateLists: () => ['secretTemplates'] as const,
  templateList: (tenantId?: UUID) => ['secretTemplates', tenantId] as const,
  templateDetails: () => ['secretTemplate'] as const,
  templateDetail: (tenantId?: UUID, templateId?: UUID) =>
    ['secretTemplate', tenantId, templateId] as const,
};

export const secretMutationKeys = {
  createSecret: (tenantId?: UUID) => ['createSecret', tenantId] as const,
  createSecretTemplate: (tenantId?: UUID) =>
    ['createSecretTemplate', tenantId] as const,
  deleteSecret: (tenantId?: UUID) => ['deleteSecret', tenantId] as const,
  deleteSecretTemplate: (tenantId?: UUID) =>
    ['deleteSecretTemplate', tenantId] as const,
  updateSecretName: (tenantId?: UUID, secretId?: UUID) =>
    ['updateSecretName', tenantId, secretId] as const,
  updateSecretTemplate: (tenantId?: UUID, templateId?: UUID) =>
    ['updateSecretTemplate', tenantId, templateId] as const,
  updateSecretValue: (tenantId?: UUID) =>
    ['updateSecretValue', tenantId] as const,
  accessSecret: (tenantId?: UUID, secretId?: UUID) =>
    ['accessSecret', tenantId, secretId] as const,
};
